import { createContext, type RefObject } from 'react';

/** A PNG data URL or an image blob of what a view shows right now. */
export type SourceFrame = Blob | string | null;

/**
 * A view the page renderer cannot see into (a WebGL scene, a sandboxed frame),
 * drawn from its own capture over the place it occupies on screen.
 */
export interface SnapshotSource {
  /** Where the view is on screen; skipped while it is not mounted. */
  readonly elementRef: RefObject<HTMLElement | null>;
  readonly kind: string;
  readonly capture: () => SourceFrame | Promise<SourceFrame>;
}

export interface ViewSnapshotRegistry {
  readonly rootRef: RefObject<HTMLDivElement | null>;
  readonly sources: Set<SnapshotSource>;
}

export const ViewSnapshotContext = createContext<ViewSnapshotRegistry | null>(null);
